export default {
  slug: "fair-treatment",
  title: "Fair treatment of customers",
  tier: "UK lending",
  group: "uk",
  appliesTo: "Daksfirst Limited; UK lending",
  lead: "Our lending is not regulated by the Financial Conduct Authority. We hold ourselves to the standards a regulated lender would apply regardless.",
  sections: [
    { id: "statement", h: "Our commitment", body: [
      "Daksfirst's lending is to companies and to experienced property investors and is not regulated by the Financial Conduct Authority. We hold ourselves to the standards a regulated lender would apply regardless.",
      "We design products that do what they say, price them so that the cost is clear before you commit, explain them in language you can act on, and support you through the life of the loan and particularly when things go wrong. Our facility letters state every fee, the interest rate, how interest is charged, the repayment date and what happens if it is missed. We do not charge fees of a type that is not in our published tariff, or an amount that is not in your facility letter. We do not lend where we cannot see a credible exit, because a loan that cannot be repaid is bad for both of us.",
      "Our Complaints, Financial difficulty and Vulnerable customers pages say what we do when something goes wrong, and we mean them."
    ]}
  ],
  version: "1.0",
  status: "Effective 22 September 2026",
  owner: "Director"
};
